import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input, Label } from '../components/ui/input';
import { Lock, Mail } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.successMessage;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await login(email, password);
      console.log('Login result:', result);
      setTimeout(() => navigate('/redirect'), 500);
    } catch (err) {
      setError('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-primary-light flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary font-outfit mb-2">Passerelle</h1>
          <p className="text-foreground-muted">Espace professionnel</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-card p-8" data-testid="login-form">
          <h2 className="text-2xl font-semibold text-slate-800 mb-6">Connexion</h2>

          {successMessage && (
            <div className="mb-6 p-3 bg-green-50 border border-green-200 rounded-xl text-sm text-green-700 font-outfit text-center">
              ✓ {successMessage}
            </div>
          )}

          {/* Demo Info */}
          <div className="mb-6 p-4 bg-primary-light rounded-xl border border-primary/20">
            <p className="text-sm text-slate-700 font-medium mb-2">Compte de démonstration :</p>
            <p className="text-sm text-slate-600">Email: <span className="font-mono">lea.dubois@passerelle.fr</span></p>
            <p className="text-sm text-slate-600">Mot de passe: <span className="font-mono">demo123</span></p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="email"
                  type="email"
                  placeholder="votre.email@exemple.fr"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="pl-11"
                  required
                  data-testid="email-input"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-11"
                  required
                  data-testid="password-input"
                />
              </div>
            </div>

            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600" data-testid="error-message">
                {error}
              </div>
            )}

            <Button 
              type="submit" 
              className="w-full" 
              disabled={loading}
              data-testid="login-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
